module.exports = __webpack_public_path__ + "img/76.2d92082f.jpg";